var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.loginClickHandler}},[_vm._v("没看错，我就是登陆按钮")])}
var staticRenderFns = []

export { render, staticRenderFns }